import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { RequireAuth } from "./components/RequireAuth";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { TenantsPage } from "./pages/TenantsPage";
import { SitesPage } from "./pages/SitesPage";
import { SiteDetailPage } from "./pages/SiteDetailPage";
import { PagesPage } from "./pages/PagesPage";
import { GoalsPage } from "./pages/GoalsPage";
import { HeatmapPage } from "./pages/HeatmapPage";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/tenants" replace />} />
                  <Route path="/tenants" element={<TenantsPage />} />
                  <Route path="/tenants/:tenantId/sites" element={<SitesPage />} />
                  <Route path="/sites/:siteId" element={<SiteDetailPage />} />
                  <Route path="/sites/:siteId/pages" element={<PagesPage />} />
                  <Route path="/pages/:pageId/heatmap" element={<HeatmapPage />} />
                  <Route path="/sites/:siteId/goals" element={<GoalsPage />} />
                  <Route path="*" element={<Navigate to="/tenants" replace />} />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
